// removed by extract-text-webpack-plugin
module.exports = {"hidden":"aDvto","visuallyhidden":"PzETi","hide-text":"_2QSuP","center":"_123ql","noprint":"_33lqk","topBanner":"_1z2yv _25KE7","tippebannerDiscaimer":"LVbgo","tippebanner":"_2Iz54","stretch":"_2yB_6"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-embed-wrapper/styles/default.scss
 ** module id = 996
 ** module chunks = 2
 **/